module.exports = __webpack_public_path__ + "static/media/sad-guy.a0e49148.svg";